/**
 * Tipos do Extrato Consolidado do Portal do Credenciado.
 *
 * Uma lista única que combina lançamentos de três origens — medição,
 * demonstrativo e multa — em ordem cronológica, cada um com o efeito no saldo
 * acumulado do credenciado. Sem `docs/MODELO-DE-DADOS.md` para esta visão
 * ainda (nenhuma tabela existe no banco): os campos aqui nascem do protótipo
 * e do bom senso, não de migração.
 */

export type TipoDeLancamento = 'medicao' | 'demonstrativo' | 'multa';

export interface LancamentoDoExtrato {
  id: string;
  /** Data do lançamento, formato ISO ("2026-07-15"). */
  data: string;
  tipo: TipoDeLancamento;
  descricao: string;
  /** Positivo é crédito, negativo é débito. */
  valor: number;
  /** Saldo acumulado depois deste lançamento. */
  saldo_acumulado: number;
}

/** Filtro do extrato. A paginação é sempre do servidor. */
export interface FiltroDoExtrato {
  pagina: number;
  tamanho: number;
  /** Competência no formato "yyyy-mm". Vazio filtra todos os meses. */
  competencia?: string;
}

export const TAMANHO_PAGINA_PADRAO = 10;
